import { FC, useMemo } from 'react';

import type { GetCurrentActivitiesEditorsSubscription } from '../lesson-builder.graphql.generated';
import TooltipWrapper from 'approot/shared/tooltip/tooltip-wrapper';
import * as Styled from './activity-editor-avatar.style';
import { getInitials } from './logic/get-initials';
import type { Pluck } from 'lib/gql/pluck';

interface ActiveEditorAvatarProps {
  editor: Pluck<
    GetCurrentActivitiesEditorsSubscription,
    'getCurrentActivitiesEditors'
  >;
  colorName: string;
}

const ActiveEditorAvatar: FC<ActiveEditorAvatarProps> = ({
  editor,
  colorName,
}) => {
  const initials = useMemo(
    () => getInitials(editor.firstName, editor.lastName, editor.email),
    [editor.firstName, editor.lastName, editor.email]
  );

  return (
    <TooltipWrapper
      hoverText={
        editor.firstName && editor.lastName
          ? `${editor.firstName} ${editor.lastName}`.trim()
          : editor.email || 'Unknown'
      }
    >
      <Styled.ActivityEditorAvatar
        $backgroundColor={colorName}
        $borderRadius={40}
      >
        {initials}
      </Styled.ActivityEditorAvatar>
    </TooltipWrapper>
  );
};

export default ActiveEditorAvatar;
